import {createLogger} from "redux-logger"
import {createStore, applyMiddleware, Action} from "redux"
import {createEpicMiddleware, EpicMiddleware} from "redux-observable"

// Root Reducer
import rootReducer from "./root-reducer"

// Root Epic
import rootEpic from "./root-epic"

// Redux observable epic dependencies
import Dependencies from "./dependencies"

// Models
import {EpicDependencies, RootState} from "../models"

const logger = createLogger({
    collapsed: true,
});
let developmentMiddleware = [];

if (process.env.NODE_ENV === "development") {
    developmentMiddleware.push(logger);
}

const epicMiddleware: EpicMiddleware<Action<any>, Action<any>, RootState, EpicDependencies> = createEpicMiddleware({
    dependencies: Dependencies,
});

const middleware = applyMiddleware(
    epicMiddleware,
    ...developmentMiddleware,
);

const PRELOADED_STATE = {};

/**
 * @param preloadedState - Redux preloaded state
 */
export default function getReduxStore(preloadedState = PRELOADED_STATE) {
    const store = createStore(rootReducer, preloadedState, middleware);

    epicMiddleware.run(rootEpic);

    return store
}
